module.exports = __webpack_public_path__ + "img/menu7.bf56d97a.png";